import { createGlobalStyle } from "styled-components"

const NavbarStyle = createGlobalStyle`

.nav {
  width: 100%;
  background-color: transparent;
  position: relative;
}

.nav > .nav-header {
  display: inline;
}

.nav > .nav-header > .nav-title {
  display: inline-block;
  color: #fff;
  padding: 10px 1rem 10px 10px;
}

.nav > .nav-header > .nav-title a {
  display: flex;
  text-decoration: none;
}

/*Botão escondido*/
.nav > .nav-btn {
  display: none;
}

.nav > .nav-links {
  display: inline;
  float: right;
  font-size: 1.11em;
}

.nav > .nav-links > a {
  display: inline-block;
  padding: 12px 10px 12px 10px;
  text-decoration: none;
  color: #efefef;
}

.nav > .nav-links > a:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/*Checkbox escondido*/
.nav > #nav-check {
  display: none;
}

@media (max-width:600px) {
  .nav > .nav-btn {
    display: inline-block;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .nav > .nav-btn > label {
    color: #ffffffbb;
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 8px 10px;
  }
  .nav > .nav-btn > label:hover,.nav  #nav-check:checked ~ .nav-btn > label {
    background-color: rgba(0, 0, 0, 0.3);
  }
  .nav > .nav-btn > label > span {
    display: block;
    width: 25px;
    height: 10px;
    border-top: 2px solid #eee;
  }
  .nav > .nav-links {
    position: absolute;
    display: block;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    height: 0px;
    transition: all 0.3s ease-in;
    overflow-y: hidden;
    top: 50px;
    left: 0px;
  }
  .nav > .nav-links > a {
    display: block;
    width: 100%;
  }
  .nav > #nav-check:not(:checked) ~ .nav-links {
    height: 0px;
  }
  .nav > #nav-check:checked ~ .nav-links {
    height: calc(100vh - 50px);
    overflow-y: hidden;
  }
}
`

export default NavbarStyle 